const translation = {
  allTags: 'All Tags',
  searchTags: 'Search Tags',
  tags: {
    agent: 'Agent',
    search: 'Search',
    image: 'Image',
    videos: 'Videos',
    weather: 'Weather',
    finance: 'Finance',
    design: 'Design',
    travel: 'Travel',
    social: 'Social',
    news: 'News',
    medical: 'Medical',
    productivity: 'Productivity',
    education: 'Education',
    business: 'Business',
    entertainment: 'Entertainment',
    utilities: 'Utilities',
    other: 'Other',
  },
}

export default translation
